document.addEventListener('DOMContentLoaded', function() {
    const selectors = {
        behalfOfFields: '[data-behalf-fields]',
        onBehalfCheckbox: '[data-behalf-checkbox]'
    }

    const onBehalfCheckbox = document.querySelector(selectors.onBehalfCheckbox);
    const behalfOfFields = document.querySelector(selectors.behalfOfFields);
    const behalfOfInputFields = behalfOfFields.querySelectorAll('input');

    if(!behalfOfFields || !onBehalfCheckbox) return;

    onBehalfCheckbox.addEventListener('change', function() {
        behalfOfFields.classList.toggle('DG-show');
        for (let i = 0; i < behalfOfInputFields.length; i++) {
            const input = behalfOfInputFields[i];
            input.toggleAttribute('disabled');
            input.toggleAttribute('required');
        }

    });
});